import React from 'react';
import ComboSelect from 'react-combo-select';
import FestivalItem from './FestivalItem';
import EcoRequireAmount from './EcoRequireAmount';

class FestivalCal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          itemList : [
            {no1ItemCd : "0001", no2ItemCd :"0011",co2Emissions:0}
          ],
          sumCo2Emissions:0
        };

        fetch('https://ecofestivalcalculate.du.r.appspot.com/getCofficient')
            .then(res=>res.json())
            .then(data=>co2CoefficientArr=data.arr);
    }


  fn_addItem = () => {
    const { itemList } = this.state;
    this.setState({
      itemList: itemList.concat({ no1ItemCd:"0001", no2ItemCd:"0011",co2Emissions:"0"})
    });
  }

  fn_updateIemInfo = (index,updateitem) =>{
    let items = [...this.state.itemList];
    // 2. Make a shallow copy of the item you want to mutate
    let item = {...items[index]};
    item  = updateitem;
    items[index] = item;
    // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
    // 5. Set the state to our new copy
    this.setState({itemList:items});
  }

  fn_deleteitem = (index) =>{
    console.log(index);
    let items = [...this.state.itemList];
    // 2. Make a shallow copy of the item you want to mutate
    items.splice(index,1);
    this.setState({itemList:items});
    //let item = {...items[index]};
  }

  fn_calCo2Emission = (index,count) => {
    let items = [...this.state.itemList];
    let item = {...items[index]};
    let cofficient= 0;
    for(let i in co2CoefficientArr){
      if(co2CoefficientArr[i].codevalue == item.no2ItemCd){
        cofficient = co2CoefficientArr[i].coefficient;
          break;
      }
    }
    let co2Emissions = cofficient * count;

    item.co2Emissions = co2Emissions;
    items[index] = item;
    this.setState({itemList:items});

  }

  render() {
    const {itemList} = this.state;
    let sumCo2Emissions = 0;
    for(let i in itemList){
      sumCo2Emissions += itemList[i].co2Emissions;
    }
    sumCo2Emissions =parseFloat(sumCo2Emissions).toFixed(4);

    return (
      <div className="main_body_content">
        <div style={titleStyle}>
          <h2> 행사 운영 시 탄소 배출량 측정  </h2>
        </div>
        <div style={inputDivStyle}>
          <div>
            {this.state.itemList.map((item, i) => {
                   return (<FestivalItem no1ItemCd={item.no1ItemCd}
                                       no2ItemCd={item.no2ItemCd}
                                       co2Emissions={item.co2Emissions}
                                       itemIndex={i}
                                       fn_updateitem={this.fn_updateIemInfo}
                                       fn_deleteitem={this.fn_deleteitem}
                                       fn_calCo2Emission={this.fn_calCo2Emission}
                            />);
            })}
          </div>
        </div>

        <div style={co2SumResultDivStyle}>
         총 CO₂ 배출량 : {sumCo2Emissions}
        </div>

        <div style={addDivStyle}>
          <button style={inputButtonStyle} onClick={this.fn_addItem}>
            항목추가
          </button>
        </div>
        <EcoRequireAmount co2Emissions={sumCo2Emissions}/>
      </div>
    );
  }
}


let co2CoefficientArr = [];
const  co2SumResultDivStyle = {
  marginTop : "50px"

}
const titleStyle = {
  borderBottom:"1px solid",
  marginBottm:"50px"
}
const inputDivStyle  = {
}
const inputButtonStyle={
  height:"50px",
  width:"150px",
  color:"white",
  background:"#002060"
}
const addDivStyle ={
  marginTop : "50px"
}

FestivalCal.defaultProps = {
    menuName: 'Default Name',
};

export default FestivalCal;
